import React, { useCallback, useEffect, useState } from 'react';

import type { AppData } from './appdata';
import type { NotificationToast } from './stdtypes';

export const AppDataContext = React.createContext<AppData | null>(null);

export function useAppData() {
    return React.useContext(AppDataContext) as AppData;
}

export function useNotificationToasts() {
    const [toasts, setToasts] = useState<NotificationToast[]>([]);
    const appData = useAppData();

    const updateToasts = useCallback(() => {
        setToasts(appData ? appData.getNotificationToasts() : []);
    }, [appData]);

    useEffect(() => {
        updateToasts();
        if (!appData) {
            return;
        }
        const unsubscribe = appData.subscribeToNotificationToasts(updateToasts);
        return unsubscribe;
    }, [appData, updateToasts]);

    return toasts;
}
